var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"vs-input--label",attrs:{"for":"month"}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]),_c('datepicker',{attrs:{"id":"month","format":_vm.dateFormat,"minimumView":'month',"maximumView":'month'},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }